module.exports = __webpack_public_path__ + "assets/images/pages/fundivisa/icon-fundivisa-2.png?2d5d2146";